var _rect, _ellipse, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStakeButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0913086,
    width: 24,
    height: 24,
    rx: 4,
    fill: "url(#paint0_linear_624_1142)",
    fillOpacity: 0.8
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0912,
    cy: 9.34158,
    rx: 6.25523,
    ry: 2.74075,
    fill: "#F4FFFB",
    fillOpacity: 0.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0874 11.2996C17.3184 12.4317 14.9248 13.2573 12.0912 13.2573C9.2575 13.2573 6.86391 12.4317 6.09495 11.2996C5.92643 11.5477 5.83594 11.8105 5.83594 12.0826C5.83594 13.5963 8.6365 14.8233 12.0912 14.8233C15.5458 14.8233 18.3464 13.5963 18.3464 12.0826C18.3464 11.8105 18.2559 11.5477 18.0874 11.2996Z",
    fill: "#DDFEF0",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0874 13.8752C17.3184 15.0074 14.9248 15.833 12.0912 15.833C9.2575 15.833 6.86391 15.0074 6.09495 13.8752C5.92643 14.1234 5.83594 14.3862 5.83594 14.6583C5.83594 16.1719 8.6365 17.399 12.0912 17.399C15.5458 17.399 18.3464 16.1719 18.3464 14.6583C18.3464 14.3862 18.2559 14.1234 18.0874 13.8752Z",
    fill: "#DDFEF0",
    fillOpacity: 0.87
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_624_1142",
    x1: 24.0913,
    y1: -0.00000523869,
    x2: -0.506971,
    y2: 0.629711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAF5D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7CE0D6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeButton);
export default __webpack_public_path__ + "static/media/stakeButton.e11dfc186058bb570a18d758c8a65580.svg";
export { ForwardRef as ReactComponent };